import type { ReactNode } from 'react';

type MessageRichWithMetaProps = {
  body: ReactNode;
  meta: ReactNode;
  bodyClassName?: string;
  className?: string;
};

/** Как MessageTextWithMeta, но тело — произвольный React (markdown и т.п.). */
export function MessageRichWithMeta({ body, meta, bodyClassName, className }: MessageRichWithMetaProps) {
  return (
    <div className={['chatAssistant__dmTextWithMeta', className].filter(Boolean).join(' ')}>
      <div className={['chatAssistant__dmTextWithMetaBody', bodyClassName].filter(Boolean).join(' ')}>
        {body}
        <span className="chatAssistant__dmTextWithMetaMeta">{meta}</span>
      </div>
    </div>
  );
}
